import { twMerge } from 'tailwind-merge';

export default twMerge;
